<script>
import AdaptersOverlayPanel from "../../../component/adapters/OverlayPanel.vue";
import AppMixin from "../../../mixins/AppMixin";
import ClusterApi from "../../../api/ClusterApi";
import {Listeners} from "../../../constants/listeners";
import Button from "primevue/button";
import RadioButton from "primevue/radiobutton";
import Divider from "primevue/divider";
import {store} from "../store";
import AdaptersDialog from "../../../component/adapters/Dialog.vue";

export default {
    name: 'ClusterHistory',
    mixins: [AppMixin],
    props: {
        uid: {
            type: String,
            required: true,
        }
    },
    data () {
        return {
            history: {},
            loading: false,
            first: 0,
            current: 0,
            loadedCurrent: 0,
            max: 0,
        }
    },
    watch: {
        current(newVal, oldVal) {
            if (oldVal === 0) {
                return
            }
            this.restoreAction();
        },
    },
    created() {

    },
    methods: {
        onOpen(e) {
            if (this.$refs.overlay.isOpen) {
                this.$refs.overlay.hide();
                return;
            }
            this.$refs.overlay.show(e);
            this.loading = true;
            ClusterApi
                .getClusterHistory(this.uid)
                .then(response => {
                    this.history = response
                    for (const [idx, data] of Object.entries(this.history)) {
                        let id = parseInt(idx)
                        if (this.first === 0) {
                            this.first = id
                        }
                        if (data.selected === true) {
                            this.loadedCurrent = id
                            this.current = id
                        }
                        if (id > this.max) {
                            this.max = id
                        }
                    }
                })
                .catch(error => this.alertError(error.message))
                .finally(() => this.loading = false);
        },
        getUID(idx) {
            return "hist" + idx
        },
        isActive(idx) {
            return parseInt(idx) === this.current
        },
        restoreAction() {
            this.loading = true;
            ClusterApi
                .restoreHistory(this.uid, {"to": this.current})
                .then(() => {
                    this.$emitter.emit(Listeners.CLUSTER_TREE_RELOAD);
                    store.mutations.clearSelectNode();
                    store.mutations.clearSelectNodes();
                })
                .catch(error => this.alertError(error.message))
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    computed: {
        getListenerOpenDialog() {
            return Listeners.CLUSTER_POPUP_HISTORY_OPEN;
        },
        getListenerCloseDialog() {
            return Listeners.CLUSTER_POPUP_HISTORY_CLOSE;
        },
    },
    components: {
        AdaptersDialog,
        AdaptersOverlayPanel,
        Button,
        Divider,
        RadioButton,
    }
}
</script>
<template>
    <div class="item">
        <Button
            :label="$t('lang.cluster.history.button')"
            :title="$t('lang.cluster.history.button')"
            icon="pi pi-history"
            @click="onOpen"
            class="flex w-full sm:w-auto"
            size="small"
            :pt="{
                    icon: {class: 'mr-0 sm:mr-2 hidden sm:inline-block'},
                }"
        />
        <AdaptersOverlayPanel
            :listener-id="getListenerOpenDialog"
            :listener-close-id="getListenerCloseDialog"
            class="item tooltip-target"
            title="title"
            placement="right-start"
            ref="overlay"
            :loading="this.loading"
        >
            <div class="slot-container">
                <div class="formgroup-inline">
                    <label>{{$t('lang.cluster.history.label')}}</label>
                    <div class="col flex-column flex-nowrap overflow-auto pb-0">
                        <div class="field-radiobutton" v-for="(data, idx) in history">
                            <RadioButton
                                v-model="current"
                                :inputId="getUID(idx)"
                                :name="getUID(idx)"
                                :value="parseInt(idx)"
                            />
                            <label :for="getUID(idx)" :class="{active: isActive(idx)}">{{data.label}}</label>
                        </div>
                    </div>
                </div>
            </div>
        </AdaptersOverlayPanel>
    </div>
</template>

<style>
.slot-container {
    max-width: 430px;
}
.formgroup-inline .col {
    max-height: 324px;
    padding-left: 0;
}
.field-radiobutton label {
    font-weight: 400;
    font-size: 14px;
    font-family: Roboto, sans-serif;
}
.field-radiobutton label.active {
    font-weight: 700;
}

</style>
